import { DeviceDetectorService } from 'ngx-device-detector';
import { Injectable } from '@angular/core';
import { LoggerInterface } from './logger.interface';
import { RestLogger } from './rest-logger';
import { environment } from 'environments/environment';
import { filter } from 'rxjs/operators';
import { GlobalVariable } from 'app/shared/global';

@Injectable()
export class LoggerService {
  private logger: RestLogger;
  private browserDetails: string;

  constructor(private deviceDetector: DeviceDetectorService) {
    this.browserDetails = JSON.stringify(this.deviceDetector.getDeviceInfo());
    this.initialize();
  }

  public initialize() {
    this.logger = new RestLogger('AmberUI', GlobalVariable.BASE_API_URL + 'api/logger/log');
  }

  public logHttpInfo(info: any, elapsedTime: number, requestPath: string) {
    // TODO: create and set correlation id
    const url = location.href;
    const logFields: LoggerInterface = {
      environment: 'prod',
      browser: this.browserDetails,
      requestPath,
      elapsedTime,
      url,
    };

    this.logger.log('Info', this.maskCC(`${info}`), logFields);
  }

  public logError(errorMsg: string) {
   
  }

  public maskCC(message: string) {
    var ccObject = JSON.parse(message);
    if (ccObject) {
      if (ccObject.request && ccObject.request['CardNumber']) {
        if (!ccObject.request['CardNumber'].startsWith("[masked]")) {
          ccObject.request['CardNumber'] = '[masked]-' + ccObject['CardNumber'].substr(ccObject['CardNumber'].length - 4);
        }
        ccObject.request['CCV'] = '[masked]';
        ccObject.request['ExpireMonth'] = '[masked]';
        ccObject.request['CardZipCode'] = '[masked]';
      }

      if (ccObject.response) {
        if (ccObject.response.results) {
          let cards: any[] = ccObject.response.results[0].cards;

          if (cards && cards.length > 0) {
            cards.forEach(card => {
              if (card) {
                if (card['expiryDate']) {
                  card['expiryDate']="[masked]";
                }

                if (card['paymentAccount']) {
                  card['paymentAccount']['expireMonth']=99;
                  card['paymentAccount']['expireYear']=99;
                }
              }
            });
          }
        }
      }

      return this.maskDobAndPIN(JSON.stringify(ccObject));
    }
    if (message.indexOf('CardNumber') > -1) {
      return 'Masking Error';
    }
    return message;
  }

  public maskDobAndPIN(message) {
    var jsonObj = JSON.parse(message);
    if (jsonObj) {
      if (jsonObj.request) {
        if (jsonObj.request['date_of_birth']) {
          jsonObj.request['date_of_birth'] = "[masked]";
        }

        if (jsonObj.request['dateOfBirth']) {
          jsonObj.request['dateOfBirth'] = "[masked]";
        }

        if (jsonObj.request['acc_pin']) {
          jsonObj.request['acc_pin'] = "[masked]";
        }

        if (jsonObj.request['authCallMethod']) {
          jsonObj.request['authCallMethod'] = "[masked]";
        }

        if (jsonObj.request['token']) {
          jsonObj.request['token'] = "[masked]";
        }
      }

      if (jsonObj.response) {
        if (jsonObj.response.results) {
          let persons: any[] = jsonObj.response.results[0].personal;
          if (persons && persons.length > 0) {
            persons.forEach(person => {
              if (person['dateOfBirth']) {
                person['dateOfBirth'] = "[masked]";
              }

              if (person['authCallMethod']) {
                person['authCallMethod'] = "[masked]";
              }
            });
          }
        }

        if (jsonObj.response['token']) {
          jsonObj.response['token'] = "[masked]";
        }

      }

      return JSON.stringify(jsonObj);
    }
    if (message.indexOf('date_of_birth') > -1 || message.indexOf('auth_call_method') > -1) {
      return 'Masking Error';
    }
    return message;
  }

  public logInfo(info: any) {
    const url = location.href;

    const logFields: LoggerInterface = {
      environment: 'prod',
      browser: this.browserDetails,
      requestPath: '',
      elapsedTime: 0,
      url,
    };

    this.logger.log('Info', this.maskCC(info), logFields);
  }
}



// WEBPACK FOOTER //
// ./src/app/logger/logger.service.ts